import { render, staticRenderFns } from "./affirm.vue?vue&type=template&id=1874df9c&scoped=true"
import script from "./affirm.vue?vue&type=script&lang=js"
export * from "./affirm.vue?vue&type=script&lang=js"
import style0 from "./affirm.vue?vue&type=style&index=0&id=1874df9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874df9c",
  null
  
)

export default component.exports